import axios from "axios";
import { getUrlApi } from "../utilities/util";
import { translateLanguagesList } from "../utilities/util";
import i18n from "i18next"; 
import ApiHandler from './ApiHandlers/ApiHandler'; 

export const baseURL = String(getUrlApi());

export default class SecurityApi {    
  static async Login(userName: string, password: string): Promise<any> { 
    const translateName = translateLanguagesList().find((item: any) => item.code === i18n.language) 
    const lg = translateName !== undefined ? translateName.name.toLowerCase() : 'pt-br'; 
    return axios.post(`${baseURL}/${lg}/api/security/login`, { userName, password }, { withCredentials: true })
  };

  static async refreshToken(): Promise<any> { 
    const translateName = translateLanguagesList().find((item: any) => item.code === i18n.language) 
    const lg = translateName !== undefined ? translateName.name.toLowerCase() : 'pt-br' 
    // Não precisamos mais enviar o token no corpo da requisição, pois ele está nos cookies
    return axios.post(`${baseURL}/${lg}/api/security/refreshtoken`, {}, { withCredentials: true })
  };
  
  static async Logout(): Promise<any> {
    const translateName = translateLanguagesList().find((item: any) => item.code === i18n.language) 
    const lg = translateName !== undefined ? translateName.name.toLowerCase() : 'pt-br' 
    return axios.post(`${baseURL}/${lg}/api/security/logout`, {}, { withCredentials: true })
  };

  static LogoutBeacon(): void {
    if (typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") {
      SecurityApi.LogoutFetchFallback();
      return;
    }

    const translateName = translateLanguagesList().find(
      (item: any) => item.code === i18n.language,
    );
    const lg = translateName !== undefined ? translateName.name.toLowerCase() : "pt-br";

    const url = `${baseURL}/${lg}/api/security/logout`;

    try {
      const body = JSON.stringify({});
      const payload = new Blob([body], { type: "application/json" });
      const sent = navigator.sendBeacon(url, payload);

      if (!sent) {
        SecurityApi.LogoutFetchFallback(url, body);
      }
    } catch (error) {
      console.error("Falha ao enviar beacon de logout:", error);
      SecurityApi.LogoutFetchFallback(url, JSON.stringify({}));
    }
  }

  private static LogoutFetchFallback(url?: string, body?: string): void {
    if (typeof fetch !== "function") {
      return;
    }

    const translateName = translateLanguagesList().find(
      (item: any) => item.code === i18n.language,
    );
    const lg = translateName !== undefined ? translateName.name.toLowerCase() : "pt-br";
    const targetUrl = url ?? `${baseURL}/${lg}/api/security/logout`;
    const targetBody = body ?? JSON.stringify({});

    try {
      fetch(targetUrl, {
        method: "POST",
        credentials: "include",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
        },
        body: targetBody,
      }).catch((error) => {
        console.error("Falha no fetch keepalive de logout:", error);
      });
    } catch (error) {
      console.error("Erro ao tentar fallback de logout:", error);
    }
  }

  static async GetError400(): Promise<any> {
    return ApiHandler(baseURL).get("/security/error400");
  }; 
  
  static async GetEnvironment(): Promise<any> {
    return ApiHandler(baseURL).get("/security/environment");
  };   

  static async Signin(form: {
    Name: string;
    Username: string;
    Email: string;
    Phone: string;
    Password: string;
    ConfirmPassword: string;
    Departament?: string | null;
    Position?: string | null;
    GroupId: string; // Guid as string
    Active: boolean;
    PlantId?: string;
  }): Promise<any> {
    return ApiHandler(baseURL).post("/security/signin", form);
  }

  static async RefreshToken(): Promise<any> { 
    // Não precisamos mais enviar o token no corpo da requisição, pois ele está nos cookies
    return ApiHandler(baseURL).post("/security/refreshtoken", {})
  }
}
